import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ScrollTopModule } from 'primeng/scrolltop';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LayoutService } from './core/services/layout.service';
import { CommonModule } from '@angular/common';
import { LOGIN_METHOD_KEY, LoginMethod } from './core/enums/login-method.enum';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ConfirmDialogModule, ToastModule, ScrollTopModule, ProgressSpinnerModule, CommonModule]
})
export class AppComponent implements OnInit {
  title = 's2-emulator';
  loading = signal(true);

  private oidcSecurityService = inject(OidcSecurityService);

  constructor(
    private layoutService: LayoutService,
  ) {
    effect(() => {
      const html = document.body.parentElement;
      if (html) {
        html.style.fontSize = this.layoutService.layoutBaseFontSize();
        // PrimeNG v20: toggle dark mode via CSS class (matches darkModeSelector in providePrimeNG config)
        if (this.layoutService.darkTheme()) {
          html.classList.add('dark-mode');
        } else {
          html.classList.remove('dark-mode');
        }
      }
    });
  }

  async ngOnInit() {
    const loginMethod = localStorage.getItem(LOGIN_METHOD_KEY);
    if (loginMethod === LoginMethod.IAM) {
      this.oidcSecurityService
        .checkAuth()
        .subscribe(() => this.loading.set(false));
    } else {
      this.loading.set(false);
    }
  }
}
